import { Alert, Text } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { ReactNode } from 'react';
import { DataSourceActions, type DataSubject } from './DataSourceActions';

type Props = {
  title: string;
  children: ReactNode;
  subjects: DataSubject[];
  siestaPrompt: string;
  testId?: string;
};

/**
 * What a tab shows when nothing is recorded yet. An empty tab is not a dead end: the two ways to
 * fill it — process the documents, or ask Siesta to read them — are the same ones the cashflow
 * models section offers, so they are rendered by the same component rather than copied.
 */
export function NoRecordedDataCallout({ title, children, subjects, siestaPrompt, testId }: Props) {
  return (
    <Alert
      variant="light"
      color="blue"
      icon={<IconInfoCircle size={18} />}
      title={title}
      data-testid={testId}
    >
      <Text size="sm">{children}</Text>
      <DataSourceActions subjects={subjects} siestaPrompt={siestaPrompt} />
    </Alert>
  );
}
